/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfigValueEnum } from '../models/ConfigValueEnum';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ModuleConfigsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Map Config Values By Type For Entity
     * @param entityId
     * @returns ConfigValueEnum Successful Response
     * @throws ApiError
     */
    public mapConfigValuesByTypeForEntity(
        entityId: string,
    ): CancelablePromise<Record<string, ConfigValueEnum>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/module-configs/map-config-values-by-type-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
